var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paragraph-list"},_vm._l((_vm.headers),function(header,index){return _c('div',{key:header,staticClass:"paragraph-list-item"},[_c('p',{staticClass:"header",domProps:{"innerHTML":_vm._s(header)}}),_c('p',{staticClass:"paragraph",domProps:{"innerHTML":_vm._s(_vm.paragraphs[index])}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }